module.exports = __webpack_public_path__ + "static/media/footer.8bd43bac.png";